export default __webpack_public_path__ + "static/media/logo.6d363f45.svg";